import { useStore } from "zustand";

import { DiscoveryFilters } from "../../components/discovery/filters";
import { AllInsightsViewer } from "../../components/discovery/insights/AllInsightsViewer";
import { UnifiedFilters } from "../../components/discovery/unifiedFilters/UnifiedFilter";
import { FeatureFlagsStore } from "../../store/featureFlags";

import { DiscoveryBody } from "./DiscoveryBody";

export const AllInsights: React.FunctionComponent = () => {
    const [useUnifiedSearch] = useStore(FeatureFlagsStore, (state) => [
        state.unifiedSearch,
    ]);

    return (
        <DiscoveryBody data-testid="discovery-body">
            {useUnifiedSearch ? <UnifiedFilters /> : <DiscoveryFilters />}
            <AllInsightsViewer />
        </DiscoveryBody>
    );
};
